import { LAYERS } from "@/data/canvas";
import { Wrench, Globe, ShieldCheck } from "lucide-react";

const ICONS = { ordinary: Wrench, self_service: Globe, governed: ShieldCheck };

export function LayerTag({ layer, showHint = false }) {
  const cfg = LAYERS[layer];
  if (!cfg) return null;
  const Icon = ICONS[layer];
  return (
    <span className="inline-flex flex-col">
      <span
        data-testid={`layer-tag-${layer}`}
        className={`inline-flex w-fit items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.1em] ${cfg.className}`}
      >
        <Icon className="h-3 w-3" />
        {cfg.label}
      </span>
      {showHint && <span className="mt-1 text-xs text-mill-muted">{cfg.hint}</span>}
    </span>
  );
}

export function LayerLegend() {
  return (
    <div className="flex flex-wrap gap-x-6 gap-y-3" data-testid="layer-legend">
      {Object.values(LAYERS).map((l) => (
        <div key={l.key} className="flex items-start gap-2">
          <LayerTag layer={l.key} />
          <span className="max-w-[15rem] text-xs text-mill-muted">{l.hint}</span>
        </div>
      ))}
    </div>
  );
}
